import React from 'react';
import classNames from 'classnames';

import Select from '../../components/select';
import TranslationIds from '../../../commons/translationIds';

import renderCustomParentEmail from './renderCustomParentEmail';
const defaultValue = '-';

function renderCustomParentConsent (p) {
    const {
        classes,
        // customFields,
        customValues,
        updateCustomValues,
        item,
        fieldErrors,
        touched,
        translate,
        translateWithValues,
    } = p;


    function getValue () {
        if (!customValues[item.name]) {
            return '-';
        }
        return customValues[item.name];
    }

    function selectionWithTranslations () {
        return [
            { value: 'yes', label: translate(TranslationIds.REGISTRATION_YES), code: 'yes' },
            { value: 'no', label: translate(TranslationIds.REGISTRATION_NO), code: 'no' },
        ];
    }

    function getDataProvider () {
        if (!touched.parentConsentOn || getValue() === defaultValue) {
            return [
                { label: `${translate(TranslationIds.REGISTRATION_SELECT)}`, value: defaultValue},
                ...selectionWithTranslations(),
            ];
        }
        return selectionWithTranslations();
    }

    function getHelperText () {
        if (item.required) {
            return `${item.value[0]}*`;
        }
        return item.value[0];
    }

    function getErrorText () {
        if (fieldErrors[item.name]) {
            return translateWithValues(TranslationIds.REGISTRATION_REQUIRED_FIELD, { label: item.name });
        }
        return '';
    }

    function renderParentEmail () {
        return renderCustomParentEmail({...p, parentConsentFieldName: item.name, parentConsentFieldRequired: item.required });
    }

    return (
        <React.Fragment>
            <Select
                className={classNames(['ecal-reg-field-custom-field-parental-consent', classes.selectUI])}
                placeHolder={getHelperText()}
                helperText={getErrorText()}
                labelHeading={getHelperText()}
                value={getValue()}
                dataProvider={getDataProvider()}
                error={fieldErrors[item.name]}
                onChange={(e, value) => {
                    
                    updateCustomValues({
                        [item.name]: value,
                    });

                  
                }}
                name={item.name}
            
            />
            { renderParentEmail() }
        </React.Fragment>
    );
}

export default renderCustomParentConsent;